<template>
  <el-dialog title="新增用户" :visible.sync="visible" :close-on-click-modal="false" width="30%" custom-class="dialogCls">
    <el-form label-width="100px" :model="form" ref="formData">
      <el-form-item label="账号" prop="loginName" :rules="ruleAccountName">
        <el-input placeholder="" v-model="form.loginName"></el-input>
      </el-form-item>

      <el-form-item label="姓名" prop="userName">
        <el-input placeholder="" v-model="form.userName"></el-input>
      </el-form-item>

      <el-form-item label="密码" prop="password" :rules="ruleAccountPwd">
        <el-input placeholder="" v-model="form.password"></el-input>
      </el-form-item>

      <el-form-item label="绑定手机号" prop="mobile" :rules="rulePhone">
        <el-input placeholder="" v-model="form.mobile"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close()">取 消</el-button>
      <el-button type="primary" @click="submit()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import accountApi from "@/api/account"
import userApi from "@/api/users"
import { validAccountName, validAccountPwd, validPhone } from "@/utils/valid"

export default {
  props: {},

  data() {
    var validAccountNameFun = (rule, value, callback) => {
      if (!validAccountName(value)) {
        callback(new Error("长度在 6 到 20 个英文/下划线/数字，第一个字母不能是下划线和数字"))
      } else {
        accountApi.checkUsernameUnique(value).then((res) => {
          if (res.code == 0) {
            callback()
          } else if (res.code == 1) {
            callback("该账号已经被占用")
          } else if (res.code == 301) {
            callback(new Error(res.data[0].msg + "333"))
          }
        })
      }
    }

    var validAccountPwdFun = (rule, value, callback) => {
      if (!validAccountPwd(value)) {
        callback(new Error("长度在 6 到 20 个字符(必须包含数字/小写字母/大写字母)"))
      } else {
        callback()
      }
    }

    var validPhoneFun = (rule, value, callback) => {
      if (!validPhone(value)) {
        callback(new Error("手机号码格式不正确"))
      } else {
        callback()
      }
    }

    return {
      visible: false,

      form: {
        loginName: "",
        userName: "",
        password: "Aa123456",
        mobile: "",
      },

      ruleAccountName: [
        {
          required: true,
          min: 6,
          max: 20,
          message: "长度在 6 到 20 个英文/下划线/数字，第一个字母不能是下划线和数字",
          trigger: "blur",
        },
        { validator: validAccountNameFun, trigger: "blur" },
      ],

      ruleAccountPwd: [
        {
          required: true,
          min: 6,
          max: 20,
          message: "长度在 6 到 20 个字符(必须包含数字/小写字母/大写字母)",
          trigger: "blur",
        },
        { validator: validAccountPwdFun, trigger: "blur" },
      ],

      rulePhone: [
        {
          required: true,
          trigger: "blur",
          message: "手机号码必须填写",
        },
        { validator: validPhoneFun, trigger: "blur" },
      ],
    }
  },
  mounted() {},
  methods: {
    open() {
      this.visible = true
    },

    submit() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          userApi.insert(this.form).then((res) => {
            if (res.code == 0) {
              this.$notify.success({
                title: "成功",
                message: res.msg,
              })
              this.visible = false
              this.form = {
                loginName: "",
                userName: "",
                password: "Aa123456",
                mobile: "",
              }
              this.$emit("submitSuccess")
            } else if (res.code == 1) {
              this.$notify.error({
                title: "错误",
                message: "提交失败," + res.msg,
              })
            }
          })
        }
      })
    },

    close() {
      this.visible = false
      this.$emit("close")
    },
  },
}
</script>

<style scoped>
.dialogCls {
  width: 40%;
  min-width: 400px;
}
</style>
